import { Union } from "./fable_modules/fable-library.3.7.20/Types.js";
import { union_type, option_type, string_type } from "./fable_modules/fable-library.3.7.20/Reflection.js";
import { FSharpResult$2 } from "./fable_modules/fable-library.3.7.20/Choice.js";
import { substring, printf, toText } from "./fable_modules/fable-library.3.7.20/String.js";
import { parseInt$ } from "./Utils.js";

export class InputString extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["StringOption", "String"];
    }
}

export function InputString$reflection() {
    return union_type("WrappedString.InputString", [], InputString, () => [[["Item", option_type(string_type)]], [["Item", string_type]]]);
}

export class String64 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["String64"];
    }
}

export function String64$reflection() {
    return union_type("WrappedString.String64", [], String64, () => [[["Item", string_type]]]);
}

export function String64Module_create(str) {
    if ((!(str == null)) && (str.length <= 64)) {
        return new FSharpResult$2(0, new String64(0, str));
    }
    else {
        return new FSharpResult$2(1, toText(printf("A String64 needs to be less than or equal to 64 characters (and cannot be null). The error string is \u0027%s\u0027"))(str));
    }
}

export function String64Module_value(_arg) {
    return _arg.fields[0];
}

export class String40 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["String40"];
    }
}

export function String40$reflection() {
    return union_type("WrappedString.String40", [], String40, () => [[["Item", string_type]]]);
}

export function String40Module_create(str) {
    if ((!(str == null)) && (str.length <= 40)) {
        return new FSharpResult$2(0, new String40(0, str));
    }
    else {
        return new FSharpResult$2(1, toText(printf("A String40 needs to be less than or equal to 40 characters (and cannot be null). The error string is \u0027%s\u0027"))(str));
    }
}

export function String40Module_value(_arg) {
    return _arg.fields[0];
}

export class String30 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["String30"];
    }
}

export function String30$reflection() {
    return union_type("WrappedString.String30", [], String30, () => [[["Item", string_type]]]);
}

export function String30Module_create(str) {
    if ((!(str == null)) && (str.length <= 30)) {
        return new FSharpResult$2(0, new String30(0, str));
    }
    else {
        return new FSharpResult$2(1, toText(printf("A String30 needs to be less than or equal to 30 characters (and cannot be null). The error string is \u0027%s\u0027"))(str));
    }
}

export function String30Module_value(_arg) {
    return _arg.fields[0];
}

export class String12 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["String12"];
    }
}

export function String12$reflection() {
    return union_type("WrappedString.String12", [], String12, () => [[["Item", string_type]]]);
}

export function String12Module_create(str) {
    if ((!(str == null)) && (str.length <= 12)) {
        return new FSharpResult$2(0, new String12(0, str));
    }
    else {
        return new FSharpResult$2(1, toText(printf("A String12 needs to be less than or equal to 12 characters (and cannot be null). The error string is \u0027%s\u0027"))(str));
    }
}

export function String12Module_value(_arg) {
    return _arg.fields[0];
}

export class String3 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["String3"];
    }
}

export function String3$reflection() {
    return union_type("WrappedString.String3", [], String3, () => [[["Item", string_type]]]);
}

export function String3__get_Value(this$) {
    return this$.fields[0];
}

const String3Module_errorMsg = (() => {
    const clo = toText(printf("A String3 needs to be less than or equal to 3 characters (and cannot be null). The error string is \u0027%s\u0027"));
    return clo;
})();

function String3Module_validate(str) {
    if ((!(str == null)) && (str.length <= 3)) {
        return new FSharpResult$2(0, new String3(0, str));
    }
    else {
        return new FSharpResult$2(1, String3Module_errorMsg(str));
    }
}

export function String3Module_create(_arg) {
    if (_arg.tag === 1) {
        return String3Module_validate(_arg.fields[0]);
    }
    else {
        const strOpt = _arg.fields[0];
        if (strOpt == null) {
            return new FSharpResult$2(1, String3Module_errorMsg("null"));
        }
        else {
            return String3Module_validate(strOpt);
        }
    }
}

export function String3Module_value(_arg) {
    return _arg.fields[0];
}

export class NonEmptyString extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["NonEmptyString"];
    }
}

export function NonEmptyString$reflection() {
    return union_type("WrappedString.NonEmptyString", [], NonEmptyString, () => [[["Item", string_type]]]);
}

export function NonEmptyStringModule_create(str) {
    if ((!(str == null)) && (str.length > 0)) {
        return new FSharpResult$2(0, new NonEmptyString(0, str));
    }
    else {
        return new FSharpResult$2(1, toText(printf("A NonEmptyString needs to be at least 1 character (and cannot be null).")));
    }
}

export function NonEmptyStringModule_value(_arg) {
    return _arg.fields[0];
}

export class ShortDateString extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ShortDateString"];
    }
}

export function ShortDateString$reflection() {
    return union_type("WrappedString.ShortDateString", [], ShortDateString, () => [[["Item", string_type]]]);
}

export function ShortDateStringModule_isFormattedCorrectly(str) {
    const matchValue = [parseInt$(substring(str, 0, 4)), parseInt$(substring(str, 5, 2)), parseInt$(substring(str, 8, 2))];
    let pattern_matching_result, day, month, year;
    if (matchValue[0] != null) {
        if (matchValue[1] != null) {
            if (matchValue[2] != null) {
                pattern_matching_result = 0;
                day = matchValue[2];
                month = matchValue[1];
                year = matchValue[0];
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            if (((((year > 1900) && (year < 3000)) && (month > 0)) && (month < 13)) && (day > 0)) {
                return day < 32;
            }
            else {
                return false;
            }
        }
        case 1: {
            return false;
        }
    }
}

export function ShortDateStringModule_create(str) {
    if (((!(str == null)) && (str.length === 10)) && ShortDateStringModule_isFormattedCorrectly(str)) {
        return new FSharpResult$2(0, new ShortDateString(0, str));
    }
    else {
        return new FSharpResult$2(1, toText(printf("A ShortDateString needs to be exactly 10 characters (format: yyyy-MM-dd) (and cannot be null).")));
    }
}

export function ShortDateStringModule_value(_arg) {
    return _arg.fields[0];
}

export class String100 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["String100"];
    }
}

export function String100$reflection() {
    return union_type("WrappedString.String100", [], String100, () => [[["Item", string_type]]]);
}

export function String100Module_create(str) {
    if ((!(str == null)) && (str.length <= 100)) {
        return new FSharpResult$2(0, new String100(0, str));
    }
    else {
        return new FSharpResult$2(1, toText(printf("A String100 needs to be less than or equal to 64 characters (and cannot be null). The error string is \u0027%s\u0027"))(str));
    }
}

export function String100Module_value(_arg) {
    return _arg.fields[0];
}

